module.exports = __webpack_public_path__ + "img/e409ca4.jpg";